import { render } from "./BookListView.vue?vue&type=template&id=0bdd1918&scoped=true"
import script from "./BookListView.vue?vue&type=script&lang=js"
export * from "./BookListView.vue?vue&type=script&lang=js"

import "./BookListView.vue?vue&type=style&index=0&id=0bdd1918&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdd1918"]])

export default __exports__